// extracted by mini-css-extract-plugin
export default {"day":"datePickerStyles_day__hh-AR","customStyles":"datePickerStyles_customStyles__7baNv"};